export default {
      id: "pinpoint-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#pinpoint",
      toString: function () {
        return this.url;
      }
    }